import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Navigation = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { path: '/terroir', label: 'OUR TERROIR' },
    { path: '/collection', label: 'OUR COLLECTIONS' },
    { path: '/qualite-export', label: 'QUALITY & EXPORT' },
    { path: '/recipes', label: 'RECIPES' },
    { path: '/contact', label: 'CONTACT' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#1A1915] shadow-lg">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4">
        <div className="flex items-center justify-center relative">
          <Link to="/" className="flex items-center group absolute left-0 mt-5 md:mt-[12px]">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-[#1A1915] p-2">
              <img
                src="./images/goldlogo.webp"
                alt="Legato d'Oro"
                className="w-full h-full object-contain"
                loading="eager"
              />
            </div>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                className={`inter text-sm font-medium tracking-wide transition-all duration-300 hover:text-[#C9A961] ${
                  location.pathname === link.path ? 'text-[#C9A961]' : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
            className="md:hidden text-white hover:text-[#C9A961] transition-colors absolute right-0"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-[#1A1915] border-t border-[#C9A961]/20 transition-all duration-300 ease-in-out ${
          mobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
        }`}
      >
        <div className="px-6 py-4 space-y-3">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
              className={`block py-3 px-4 rounded transition-all duration-300 ${
                location.pathname === link.path
                  ? 'bg-[#C9A961] text-[#1A1915] font-semibold'
                  : 'text-white hover:bg-[#2A2720] hover:text-[#C9A961]'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
